<template>
    <v-main>
        <v-container>
            <div style="width:100%;height:50px;"></div>
            <v-row>
                <v-col class="hidden-xs-only" ></v-col>
                <v-col cols="12" sm="10" md="8" lg="6" style="position:relative;">
                    <v-card  elevation="0" rounded="xs"  color="grey lighten-3" >
                        <v-row>
                            <v-col></v-col>
                            <v-col cols="10" sm="8" md="6" class="pa-0 text-center">
                                <v-avatar size="100" style="position: relative;top:50px;z-index:4;">
                                    <v-img :src="contact.profilepic" />
                                </v-avatar>
                            </v-col>
                            <v-col></v-col>
                        </v-row>
                        <v-row style="padding-bottom: 70px;">
                            <v-col cols="12" class="py-0">
                                <v-card  elevation="0" outlined rounded="lg">
                                    <div style="height:80px;"></div>
                                    <div class="title font-weight-light text-center">
                                        <div style="display: inline-block; max-width: 80%;">
                                            {{contact.name}}
                                        </div>
                                    </div>
                                    <div class="subtitle-2 font-weight-light text-center">
                                        <div style="display: inline-block; max-width: 80%;">
                                            Sand Coach
                                        </div>
                                    </div>
                                    <div class=" font-weight-light text-center">
                                        <div style="display: inline-block; max-width: 80%; font-size: .8em;color:#aaaaaa;">
                                            {{contact.cell}}
                                        </div>
                                    </div>
                                    <v-card-actions>
                                        <v-btn icon small color="green">
                                            <v-icon>mdi-phone</v-icon>
                                        </v-btn>
                                        <v-spacer/>
                                        <v-btn icon small color="blue lighten-2">
                                            <v-icon>mdi-message</v-icon>
                                        </v-btn>
                                        <v-spacer/>
                                        <v-btn icon small color="grey lighten-1">
                                            <v-icon>mdi-filmstrip</v-icon>
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>

                                <v-card  elevation="0" outlined rounded="lg" class="mt-4">
                                    <v-list dense>
                                        <v-list-item>
                                            <v-list-item-subtitle>Main</v-list-item-subtitle>
                                            <v-list-item-title>
                                                {{contact.cell}}
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-subtitle>Email</v-list-item-subtitle>
                                            <v-list-item-title>
                                                {{contact.email}}
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-card>
                            </v-col>
                        </v-row>
                        <div style="position: absolute;bottom:0;width:100%;">
                            <v-card  elevation="0" outlined rounded="xs">
                                <v-card-actions>
                                    <v-btn icon><v-icon>{{icons.plus}}</v-icon></v-btn>
                                    <v-spacer/>
                                    <v-btn icon><v-icon>{{icons.edit}}</v-icon></v-btn>
                                    <v-spacer/>
                                    <v-btn icon><v-icon>{{icons.share}}</v-icon></v-btn>
                                </v-card-actions>
                            </v-card>
                        </div>
                    </v-card>
                </v-col>
                <v-col class="hidden-xs-only"></v-col>
            </v-row>

        </v-container>
    </v-main>

</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'

  export default {
    name: "ContactCard",
    components: {},
    data() {
      return {
        contact:{
          name: 'Jordan Neil',
          cell: '602-502-6839',
          email: 'bribrink@gmail.com',
          profilepic: 'https://s3-us-west-2.amazonaws.com/imgforlife/tester/170420483.png',
          venmo:'',
          googlepay:'',
          paypal:''
        }
      }
    },
    computed: {
      ...mapState(['icons'])
    },
    methods: {
      ...mapActions(['get', 'post'])
    }
  }

</script>

<style scoped>

</style>